import { ACTION_TYPE } from './useBreadcrumbs';

const initialState = {
  data: [],
};

export const reducerBreadcrumbs = {
  [ACTION_TYPE]: (state = initialState, action) => {
    switch (action.type) {
      case `${ACTION_TYPE}_CALLED`:
        return {
          ...state,
          data: action.payload,
        };
      default:
        return state;
    }
  },
};
